import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { translate } from 'react-i18next';
import AddressInformation from './AddressInformation';
import {
  updateDeliveryAddress,
  deliveryDetailsDone,
  updateDeliveryType,
} from '../../stateManagement/engine/actions/OrderActions';
import { displayModal, goBack, hideModal } from '../../stateManagement/engine/actions/SessionActions';
import { deliveryTypeSelector } from '../../stateManagement/engine/selectors/deliveryTypeSelector';
import { getSupportedDeliveryTypes } from '../../utils/OrderUtils';

function mapStateToProps(state, ownProps) {
  return {
    organization: state.session.organization,
    deliveryType: deliveryTypeSelector(state),
    addresses: state.order.callerInfo.addresses || [],
    address: state.order.address || {},
    supportedDeliveryTypes: getSupportedDeliveryTypes(state.session.organization),
    ...ownProps,
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    ...bindActionCreators(
      {
        updateDeliveryAddress,
        deliveryDetailsDone,
        updateDeliveryType,
        displayModal,
        hideModal,
        goBack,
      },
      dispatch,
    ),
    ...ownProps,
  };
}

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  translate(),
)(AddressInformation);
